import { Plus } from "lucide-react";

import { withForm } from "~/components/form/app-form";
import { ArrayItemCard } from "~/components/form/fields/array-item-card";
import { Button } from "~/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card";

import { offerFormOptions } from "../offer-form-options";

const TAG_PROPERTY_OPTIONS = [
  "Number of sessions",
  "Program duration",
  "Session duration",
  "Session format",
  "Group size",
].map((v) => ({ value: v, label: v }));

export const TagsSection = withForm({
  ...offerFormOptions,
  render: function Render({ form }) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Tags</CardTitle>
          <p className="text-text-secondary text-sm">
            We recommend that you highlight key practical properties of your
            offer, for example "12 weeks" or "1:1".
          </p>
        </CardHeader>
        <CardContent className="space-y-4">
          <form.Field name="tags" mode="array">
            {(arrayField) => (
              <>
                {(arrayField.state.value ?? []).map((item, i) => (
                  <ArrayItemCard
                    key={i}
                    index={i}
                    isFirst={i === 0}
                    isLast={i === (arrayField.state.value?.length ?? 0) - 1}
                    isDeleted={item._delete === true}
                    itemLabel="tag"
                    onMoveUp={() => arrayField.moveValue(i, i - 1)}
                    onMoveDown={() => arrayField.moveValue(i, i + 1)}
                    onToggleDelete={() =>
                      form.setFieldValue(`tags[${i}]._delete`, !item._delete)
                    }
                  >
                    <form.AppField name={`tags[${i}].title`}>
                      {(field) => <field.TextField label="Title" required />}
                    </form.AppField>
                    <form.AppField name={`tags[${i}].property`}>
                      {(field) => (
                        <field.SelectField
                          label="Property"
                          options={TAG_PROPERTY_OPTIONS}
                        />
                      )}
                    </form.AppField>
                  </ArrayItemCard>
                ))}
                <Button
                  type="button"
                  variant="ghost"
                  onClick={() =>
                    arrayField.pushValue({
                      title: "",
                      property: "",
                      order: arrayField.state.value?.length ?? 0,
                      _delete: false,
                    })
                  }
                >
                  <Plus className="mr-2 h-4 w-4" /> Add Tag
                </Button>
              </>
            )}
          </form.Field>
        </CardContent>
      </Card>
    );
  },
});
